import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Terreno } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BemImovelTerrenoService extends BaseResourceService<Terreno> {

  constructor(
    protected injector: Injector
  ) {
    super(`terrenos`, injector);
  }

  public obterPorImovel(imovel: number): Observable<Terreno[]> {
    return this.http.get<Terreno>(
      `${this.login.cidade.id}/${this.api}/filtrar?imovel.id=${imovel}&orderBy=id$DESC&relations=plano_conta,imovel`,
      this.httpOptions()).pipe(
        map(res => res['content']),
        catchError(err => this.handleError(err))
      );
  }
}
